import {
  MEDIA_DURATION,
  MEDIA_FORMAT,
  MEDIA_HEIGHT,
  MEDIA_RATIO,
  MEDIA_SIZE,
  MEDIA_WIDTH
} from '../../ReusableFormFields/AdFileUpload/fields'

export const getFileError = errors => {
  return (
    errors[MEDIA_SIZE] ||
    errors[MEDIA_WIDTH] ||
    errors[MEDIA_HEIGHT] ||
    errors[MEDIA_FORMAT] ||
    errors[MEDIA_RATIO] ||
    errors[MEDIA_DURATION]
  )
}

export const getCTAListLimitedToLeadGenerationObjective = ctaList => {
  const limitList = ['APPLY_NOW', 'DOWNLOAD', 'GET_QUOTE', 'LEARN_MORE', 'SIGN_UP', 'SUBSCRIBE']
  return ctaList.filter(item => limitList.includes(item.name))
}
